import fs from 'node:fs'
import path from 'node:path'
import { resolveCliAssetPath } from '@core-engine/utils/cli-root.js'
import type { BetterstartPluginId } from '@plugin-engine/types.js'

export function pluginTemplateRoot(pluginId: BetterstartPluginId): string {
  return resolveCliAssetPath('adapters', 'next', 'plugins', pluginId)
}

export function readPluginTemplate(pluginId: BetterstartPluginId, relativePath: string): string {
  return fs.readFileSync(path.join(pluginTemplateRoot(pluginId), relativePath), 'utf-8')
}

export function listPluginSchemaTemplatePaths(pluginId: BetterstartPluginId): string[] {
  const schemasDir = path.join(pluginTemplateRoot(pluginId), 'schemas')
  if (!fs.existsSync(schemasDir)) {
    return []
  }

  return fs
    .readdirSync(schemasDir)
    .filter((entry) => entry.endsWith('.json'))
    .sort()
}
